export const brand = {
  name: "Yellow Ochre Gas",
  shortName: "Ochre Gas",
  phoneDisplay: "+44 7593 217699",
  phoneTel: "+447593217699",
  whatsapp: "https://wa.me/447593217699",
  gasEmergencyDisplay: "0800 111 999",
  gasEmergencyTel: "0800111999",
  locationLine: "Braintree CM7 3DP, UK",
  trustLine: "Local plumbing, boiler & heating engineers serving Braintree and nearby Essex areas.",
  rating: "5.0",
  reviewCount: "166",
  assets: {
    heroEngineer: "/images/Gas-engineer-at-work-in-kitchen.png",
    gasSafeEngineer: "/images/gas-safe-engineer-2.jpg",
    gasSafeBadge: "/images/gas-safe-engineer.jpg",
    googleIcon: "/images/icons8-google.svg"
  }
};

export const reviews = [
  {
    id: "1",
    name: "Haleemat Rasheex",
    text: "They are a great company, they go above and beyond to make their customers happy. Been using them for years now, would absolutely recommend.",
    rating: 5
  },
  {
    id: "2",
    name: "Fokhor Uddin",
    text: "Very good service and prices would highly recommend.",
    rating: 5
  },
  {
    id: "3",
    name: "Mohammed Nazrul Islam",
    text: "5 star service, I have used this company for my plumbing needs.",
    rating: 5
  },
  {
    id: "4",
    name: "Halimat Raheem",
    text: "They are a great company, they go above and beyond to make their customers happy. Been using them for years now, would absolutely recommend.",
    rating: 5
  },
  {
    id: "5",
    name: "Joel Meghan",
    text: "They are a great company, they go above and beyond to make their customers happy. Been using them for years now, would absolutely recommend.",
    rating: 5
  }
];

export const issueOptions = [
  { id: "water-leak", label: "Water leak", hint: "Water is leaking, dripping, or spreading" },
  { id: "no-heating", label: "No heating", hint: "Your home or workplace is cold" },
  { id: "boiler-problem", label: "Boiler problem", hint: "Fault, pressure, hot water, or error code" },
  { id: "blocked-drain", label: "Blocked drain", hint: "Sink, toilet, bath, or outside drain" },
  { id: "radiator-problem", label: "Radiator problem", hint: "Cold spots, leaks, or noisy radiators" },
  { id: "new-installation", label: "New installation", hint: "Boiler, heating, bathroom, or pipework" },
  { id: "annual-service", label: "Annual service", hint: "Boiler service or safety check" },
  { id: "not-sure", label: "Not sure", hint: "Answer simple questions and we will guide you" }
];

export const locationPages = [
  "Braintree",
  "Witham",
  "Halstead",
  "Great Notley",
  "Rayne",
  "Coggeshall",
  "Chelmsford",
  "Dunmow",
  "Colchester",
  "Essex"
];

export const services = [
  "Emergency plumbing",
  "Water leak repair",
  "Boiler repair",
  "Boiler installation",
  "Annual boiler service",
  "Gas safety certificates",
  "Radiator repairs",
  "Blocked drains",
  "General plumbing and heating"
];
